export default class SentryGraphQLError extends Error {
  constructor(message?: string, operation?: string) {
    const defaultMessage = operation
      ? `GraphQL operation failed: ${operation}`
      : "GraphQL operation failed";

    super(message || defaultMessage);
    this.name = "SentryGraphQLError";

    // Maintains prototype chain for instanceof checks
    Object.setPrototypeOf(this, SentryGraphQLError.prototype);
  }
}
